// Инфильтратор (deus_infiltrator, legendary, kw=rush) — trigger:
// На 2-й линии: не получает ответного удара при атаке + не может атаковать Героя.
// На 1-й линии: обычная атака.
//
// Реализация — флаги для combat:
//   - infiltratorBackline(card) → true, если юнит на 2-й линии — нет ответки.
//   - infiltratorCantAttackHero(card) → true, если на 2-й линии — пропуск Героя как цели.
//
// Keyword 'rush' остаётся в keywords[] (warnIfUnknownKeywords), не блокирует поведение.

export const CARD_ID = 'deus_infiltrator';

export function isInfiltratorBackline(card) {
  return card && card.id === CARD_ID && card.line === 1;
}
